import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import resources from './resource';
// eslint-disable-next-line @typescript-eslint/no-require-imports
// const resources = require('./resource');
i18n.use(initReactI18next)
    .init({
    ns: ['common', 'ebook'],
    // resources: resources,
    defaultNS: 'common',
    lng: 'zh',
    debug: false,
    interpolation: {
        escapeValue: false,
    },
})
    .then();
export default i18n;
export var LANGUAGE;
(function (LANGUAGE) {
    LANGUAGE["ZH"] = "zh";
    LANGUAGE["EN"] = "en";
})(LANGUAGE || (LANGUAGE = {}));
//# sourceMappingURL=index.js.map